import styled from '@emotion/styled';
import { Stack, Typography, colors } from '@ui-components/neo.tax';
import { ReactComponent as Confidence1 } from '@ui-components/neo.tax/dist/icons/confidence1.svg';
import { ReactComponent as Confidence2 } from '@ui-components/neo.tax/dist/icons/confidence2.svg';
import { ReactComponent as Confidence3 } from '@ui-components/neo.tax/dist/icons/confidence3.svg';

import { screenMd } from '@neo.tax/shared/utils';

export const StyledInfoColumn = styled(Stack)({
  width: '100%',
});

export const StyledLaptopColumn = styled(Stack)(
  {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  screenMd({
    display: 'hidden',
  }),
);

export const StyledImageContainer = styled.div({
  position: 'relative',
});

export const StyledLaptopImage = styled.img({
  maxWidth: 'none',
  position: 'relative',
  width: 600,
  zIndex: 2,
});

export const StyledConfidence1 = styled(Confidence1)({
  width: 59,
  height: 59,
});
export const StyledConfidence2 = styled(Confidence2)({
  width: 59,
  height: 59,
});
export const StyledConfidence3 = styled(Confidence3)({
  width: 59,
  height: 59,
});
export const StyledConfidenceText = styled(Typography)({
  color: colors.blue[200],
});

export const NumberContainer = styled(Stack)({
  height: 48,
  minWidth: 48,
});
